<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-25 11:01:37
-->
<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <!-- <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.commId"
                        clearable
                        filterable
                        placeholder="请选择小区"
                >
                <el-option v-for="item in optionList"
                            :key="item.id"
                            :label="item.commName"
                            :value="item.id" />
                </el-select>
            </div> -->
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.car_number"
                    size="mini"
                    clearable
                    placeholder="请输入车牌号查找"
                />
            </div>
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.status"
                        clearable
                        filterable
                        placeholder="请选择状态"
                >
                <el-option label="待审核" :value="1" />
                <el-option label="驳回" :value="2" />
                </el-select>
            </div>
            <!-- <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.title"
                    size="mini"
                    clearable
                    placeholder="请输入关键词查找"
                />
            </div> -->
            <div class="shaixuan-item">
                <el-button
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    @click="searchClick()"
                    icon="el-icon-search"
                >
                    查询
                </el-button>
                <!-- <el-button
                    @click="clickItem(0)"
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    icon="el-icon-plus"
                >
                    新增
                </el-button> -->
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table
                v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px"
            >
            <el-table-column prop="id"
                         label="id"
                         width="80" />
        <el-table-column prop="car_number" label="车牌号" minWidth="120" />
        <el-table-column prop="car_number" label="原车牌号" minWidth="120" >
            <template slot-scope="scope">
                <span>{{ scope.row.car_number == scope.row.old_car_number?"":scope.row.old_car_number }}</span>
            </template>
        </el-table-column>
        <el-table-column label="车辆图片" width="120" >
            <template slot-scope="scope">
                <el-image
                    style="width: 100px; height: 100px"
                    v-if="scope.row.car_pic"
                    :src="$adddom(scope.row.car_pic)"
                    :preview-src-list="[$adddom(scope.row.car_pic)]">
                </el-image>
            </template>
        </el-table-column>
          <el-table-column label="业主电话" width="120" >
            <template slot-scope="scope">
              <span v-if="scope.row.yezhu_phone">{{ scope.row.yezhu_phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="业主" width="120" >
            <template slot-scope="scope">
              <span v-if="scope.row.yezhu_name">{{ scope.row.yezhu_name }}</span>
            </template>
          </el-table-column>
        <el-table-column label="所有者图片" width="120" >
            <template slot-scope="scope">
                <el-image
                    v-if="scope.row.user && scope.row.user.avatar"
                    style="width: 100px; height: 100px"
                    :src="$adddom(scope.row.user.avatar)"
                    :preview-src-list="[$adddom(scope.row.user.avatar)]">
                </el-image>
            </template>
        </el-table-column>

        <el-table-column label="所有者电话" width="120" >
            <template slot-scope="scope">
              <span v-if="scope.row.user">{{ scope.row.user.phone }}</span>
            </template>
        </el-table-column>
        <el-table-column label="所有者" width="200" >
          <template slot-scope="scope">
            <span v-if="scope.row.user">{{ scope.row.user.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属小区" width="200" >
            <template slot-scope="scope">
              <span v-if="scope.row.user_resource">{{ scope.row.user_resource.commName }}</span>
            </template>
        </el-table-column>
        <el-table-column label="所属资源" width="200" >
            <template slot-scope="scope">
              <span v-if="scope.row.user_resource">{{ scope.row.user_resource.resourceCode }}</span>
            </template>
        </el-table-column>
        <el-table-column label="审核状态" width="200" >
            <template slot-scope="scope">
              <span v-if="scope.row.review_status == 0">待审核</span>
              <span v-if="scope.row.review_status == 2">驳回</span>
            </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="90" />
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <!-- <el-button
                                type="danger"
                                style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                                @click="clickItem(1, scope.row)"
                                >修改</el-button
                            > -->
                            <el-button
                                type="danger"
                                v-if="scope.row.review_status != 2"
                                @click="review(scope.row)"
                                style="
                                    background: #fd962b;
                                    border-color: #fd962b;
                                "
                                >审核</el-button
                            >
                            <el-button
                                type="danger"
                                @click="detail(scope.row)"
                                style="
                                    background: #1890ff;
                                    border-color: #1890ff;
                                "
                                >详情</el-button
                            >
                            <!-- <el-button
                                type="danger"
                                @click="remove(scope.row)"
                                style="
                                    background: #ff4949;
                                    border-color: #ff4949;
                                "
                                >删除</el-button
                            > -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination
                v-show="total"
                :total="total"
                :page.sync="queryParam.page"
                :limit.sync="queryParam.size"
                @pagination="getList"
            />
        </div>
        <!-- <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="660px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
                    <i
                        class="el-icon-circle-close close-btn pointer"
                        @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <commonAdd
                    ref="commonAdd"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
            </div>
        </el-drawer> -->
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showReview"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="1000px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ typeDrawer == 3 ? "审核" : "详情" }}</div>
                    <i
                        class="el-icon-circle-close close-btn pointer"
                        @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <reviewDetail
                    ref="reviewDetail"
                    v-if="typeDrawer == 4"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
                <reviewStatus
                    ref="reviewStatus"
                    v-if="typeDrawer == 3"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
            </div>
        </el-drawer>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/car";
import Qu from "@/api/tianzheng/Qu";
// import commonAdd from "./seekAdd.vue";
import reviewDetail from "./reviewDetail.vue";
import reviewStatus from "./reviewStatus.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            showReview: false,
            typeDrawer:'',
            optionList: [],
            queryParam: {
                status:'',
                commId:'',
                car_number: "",
                page: 1,
                size: 10,
            },
            total: 0,
            listLoading: false,
            tableData: [],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
        };
    },
    components: {
        Pagination,
        // commonAdd,
        reviewDetail,
        reviewStatus
    },
    created() {},
    mounted() {
        this.getList();
        this.getSelectCity()
    },
    methods: {
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            console.log("status", status);
            if (status == 1) {
                // 成功
                this.showDrawer = false;
                this.showReview = false;
                this.getList();
            } else if (status == -1) {
                // 失败
                this.showDrawer = false;
                this.showReview = false;
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false;
            this.showReview = false;
            if (this.$refs.commonAdd) {
                this.$refs.commonAdd.resetForm();
            }
        },
        /**
         * @name: 点击子项 0新增 1编辑
         * @param {*} type
         * @param {*} id
         * @return {*}
         * @desc:
         */
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.commonAdd.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
            let that = this;
            this.listLoading = true;
            fetch.reviewList(that.queryParam).then((res) => {
                that.listLoading = false;
                that.tableData = res.result.list;
                that.total = res.result.total;
            });
        },
        review(row){
            let that = this;
            this.showReview = true;
            this.typeDrawer = 3;
            // 给组件传值
            let obj = {
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.reviewStatus.initFun(obj);
            });
        },
        detail(row){
            let that = this;
            this.showReview = true;
            this.typeDrawer = 4;
            // 给组件传值
            let obj = {
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.reviewDetail.initFun(obj);
            });
        },
        remove(row) {
            let that = this;
            that.$confirm("确定删除该内容吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // 调用接口
                    fetch.remove({ id: row.id }).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
